import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import store from '../store';
import globals from '@/globals'
import toastr from '../helpers/Toastr';

// Layouts
import Layout from '@/layout/Layout2'
import LayoutBlank from '@/layout/LayoutBlank'

// Pages
import Home from '@/components/Home';
import Bug from '@/components/Bug';
import Page404 from '@/components/Page404';
import Page403 from '@/components/Page403';
import Page409 from '@/components/Page409';
import SignUp from '@/components/SignUp';
import InActive from '@/components/InActive';

//ALERTS
import AlertIndex from '@/components/alerts/Index';
import AlertView from '@/components/alerts/View';

//API USERS
import ApiUsersIndex from '@/components/users/ApiUsersIndex';
import ApiUsersEdit from '@/components/users/ApiUsersEdit';
import ApiUsersView from '@/components/users/ApiUsersView';

//CHANGELOGS
import ChangelogIndex from '@/components/changelogs/Index';
import ChangelogEdit from '@/components/changelogs/Edit';
import ChangelogView from '@/components/changelogs/View';
import ChangelogDelete from '@/components/changelogs/Delete';
import ChangelogEmail from '@/components/changelogs/Email';

//COVID Forms
import CustomFormEntryEdit from '@/components/covid/EditEntry';
import CustomFormEntryView from '@/components/covid/ViewEntry';
import CustomFormEntryDelete from '@/components/covid/DeleteEntry';
import CustomFormEntryStatus from '@/components/covid/StatusEntry';
import CustomFormIndex from '@/components/covid/Index';
import CustomFormEdit from '@/components/covid/Edit';
import CustomFormView from '@/components/covid/View';
import CustomFormDelete from '@/components/covid/Delete';
import CustomFormPDF from '@/components/covid/PDF';
import CustomFormBuildPDF from '@/components/covid/BuildPDF';

//DASHBOARD
import DashboardIndex from '@/components/dashboard/Index';
import DashboardSettings from '@/components/dashboard/Settings';
import DashboardEdit from '@/components/dashboard/Edit';
import DashboardView from '@/components/dashboard/View';
import DashboardDelete from '@/components/dashboard/Delete';
import DashboardSubscribe from '@/components/dashboard/Subscribe';

//EMAIL Alerts
import EmailAlertEdit from '@/components/email-alerts/Edit';
import EmailAlertDelete from '@/components/email-alerts/Delete';
import EmailAlertView from '@/components/email-alerts/View';

//FILE FOLDERS
import DriveIndex from '@/components/drive/IndexAlt';

import IncidentDelete from '@/components/IncidentDelete';
import IncidentForm from '@/components/IncidentForm';
import IncidentIndex from '@/components/IncidentIndex';
import IncidentView from '@/components/IncidentView';
import IncidentTrend from '@/components/IncidentTrend';
import IncidentRootCauseTrend from '@/components/IncidentRootCauseTrend';
import IncidentOsha from '@/components/IncidentOsha';
import IncidentCreate from '@/components/incidents/Create';
import IncidentPDF from '@/components/incidents/PDF';
import IncidentBuilder from '@/components/incidents/Builder';
import IncidentTypePublish from '@/components/incidents/IncidentTypePublish';
import IncidentChangeType from '@/components/incidents/ChangeType';
import IncidentImport from '@/components/incidents/Import';
import IncidentOverride from '@/components/incidents/Override';

//import InspectionDelete from '@/components/InspectionDelete';
import InspectionEdit from '@/components/inspections/Edit';
import InspectionEditAlt from '@/components/inspections/EditAlt';
import InspectionIndex from '@/components/inspections/Index';
import InspectionView from '@/components/inspections/View';
import InspectionDelete from '@/components/inspections/Delete';
import InspectionPDF from '@/components/inspections/PDF';
import InspectionImport from '@/components/inspections/Import';
import InspectionImportOffline from '@/components/inspections/ImportOffline';
import InspectionEmailPDF from '@/components/inspections/EmailPDF';
import InspectionBuildPDF from '@/components/inspections/BuildPDF';
import InspectionResultView from '@/components/inspection-results/InspectionResultView';

//Files
import FileEdit from '@/components/files/Edit';

//Inspection FORMS Builder
import FormIndex from '@/components/inspections/FormIndex';
import FormEdit from '@/components/inspections/FormEdit';
import FormView from '@/components/inspections/FormView';
import FormPDF from '@/components/inspections/FormPDF';
import FormPublish from '@/components/inspections/FormPublish';
import FormClone from '@/components/inspections/FormClone';
import FormDelete from '@/components/inspections/FormDelete';
import FormImport from '@/components/inspections/FormImport';

import JobsiteMerge from '@/components/JobsiteMerge';
import JobsiteForm from '@/components/JobsiteForm';
import JobsiteIndex from '@/components/JobsiteIndex';
import JobsiteView from '@/components/JobsiteView';
import JobsiteImport from '@/components/JobsiteImport';
import JobsiteInsuranceEdit from '@/components/JobsiteInsuranceEdit';

import JsaIndex from '@/components/JsaIndex';
import JsaList from '@/components/JsaList';
import JsaView from '@/components/JsaView';
import JsaForm from '@/components/JsaForm';
import JsaPDF from '@/components/JsaPDF';
import JsaDelete from '@/components/JsaDelete';
import JsaEmployeeSignature from '@/components/JsaEmployeeSignature';

import JsaTemplateIndex from '@/components/jsa/admin/Index';
import JsaTemplateEdit from '@/components/jsa/admin/Edit';
import JsaTemplateView from '@/components/jsa/admin/View';
import JsaTemplatePDF from '@/components/jsa/admin/PDF';
import JsaTemplateDelete from '@/components/jsa/admin/Delete';

import JsaReminderEdit from '@/components/JsaReminderEdit';
import JsaReminderDelete from '@/components/JsaReminderDelete';

import ObservationIndex from '@/components/observations/Index';
import ObservationView from '@/components/observations/View';
import ObservationEdit from '@/components/observations/Edit';
import ObservationDelete from '@/components/observations/Delete';

import UserIndex from '@/components/UserIndex';
import UserView from '@/components/UserView';
import UserForm from '@/components/UserForm';
import UserImpersonate from '@/components/UserImpersonate';
import Profile from '@/components/Profile';
import RoleRequest from '@/components/users/RoleRequest';
import CurrentJobsite from '@/components/CurrentJobsite';
import InspectionReminderForm from '@/components/InspectionReminderForm';

import DisciplinaryIndex from '@/components/employees/DisciplinaryIndex';
import DisciplinaryView from '@/components/employees/DisciplinaryView';
import DisciplinaryEdit from '@/components/employees/DisciplinaryEdit';
import DisciplinaryEmail from '@/components/employees/DisciplinaryEmail';
import DisciplinaryDelete from '@/components/employees/DisciplinaryDelete';
import DisciplinaryPDF from '@/components/employees/DisciplinaryPDF';
import DiscAlertEdit from '@/components/employees/DiscAlertEdit';

import EmployeeIndex from '@/components/employees/EmployeeIndex';
import EmployeeView from '@/components/employees/EmployeeView';
import EmployeeEdit from '@/components/employees/EmployeeEdit';
import EmployeeMerge from '@/components/employees/EmployeeMerge';
import EmployeeImport from '@/components/employees/EmployeeImport';
import EmployeeSettings from '@/components/employees/Settings';
import EmployeeRecognitionView from '@/components/employees/EmployeeRecognitionView';
import EmployeeRecognitionForm from '@/components/employees/EmployeeRecognitionForm';
import EmployeeRecognitionIndex from '@/components/employees/EmployeeRecognitionIndex';
import EmployeeRecognitionDelete from '@/components/employees/EmployeeRecognitionDelete';
import EmployeeAssignEquipment from '@/components/employees/AssignEditEquipment';
import RecogAlertEdit from '@/components/employees/RecogAlertEdit';

import EquipmentIndex from '@/components/equipment/EquipmentIndex';
import EquipmentView from '@/components/equipment/EquipmentView';
import EquipmentEdit from '@/components/equipment/EquipmentEdit';
import EquipmentImport from '@/components/equipment/Import';
import UsageForm from '@/components/equipment/UsageForm';
import TrackingForm from '@/components/equipment/TrackingForm';

import ClientIndex from '@/components/clients/ClientIndex';
import ClientForm from '@/components/clients/ClientForm';
import ClientView from '@/components/clients/ClientView';
import ClientApprovals from '@/components/clients/ClientApprovals';
import SubApprovalView from '@/components/clients/SubApprovalView';

import CorrectiveActionIndex from '@/components/actions/CorrectiveActionIndex';
import CorrectiveActionView from '@/components/actions/CorrectiveActionView';
import CorrectiveActionEdit from '@/components/actions/CorrectiveActionEdit';
import CorrectiveActionDelete from '@/components/actions/CorrectiveActionDelete';
import CorrectiveActionComplete from '@/components/actions/Complete';

import ReportInspectionCharts from '@/components/reports/ReportInspectionCharts';
import ReportRootCauseCharts from '@/components/reports/ReportRootCauseCharts';
import ReportInspectionResultsIndex from '@/components/reports/ReportInspectionResultsIndex';
import ReportCorrelation from '@/components/reports/CorrelationChart';
import NewReport from '@/components/reports/NewReport';
import ReportAvgInspectionScore from '@/components/reports/AvgInspectionScoreCharts';
import ReportAnalysis from '@/components/reports/AnalysisChart';
import InspectionResultsIndex from '@/components/reports/InspectionResultsIndex';

//REPORTS - INCIDENTS
import ReportIncidentCharts from '@/components/reports/ReportIncidentCharts';
import ReportIncidentByTotals from '@/components/reports/incidents/Totals';

//SAFETY MEETINGS
import SafetyMeetingIndex from '@/components/safety-meetings/Index';
import SafetyMeetingEdit from '@/components/safety-meetings/Edit';
import SafetyMeetingView from '@/components/safety-meetings/View';
import SafetyMeetingDelete from '@/components/safety-meetings/Delete';
import SafetyMeetingEmail from '@/components/safety-meetings/Email';
import SafetyMeetingText from '@/components/safety-meetings/Text';

//SAFETY DATA SHEETS
import SafetyDataSheetsIndex from '@/components/safety-data-sheets/Index';
import SafetyDataSheetsEdit from '@/components/safety-data-sheets/Edit';
import SafetyDataSheetsView from '@/components/safety-data-sheets/View';
import SafetyDataSheetsDelete from '@/components/safety-data-sheets/Delete';
import SafetyDataSheetsImport from '@/components/safety-data-sheets/ImportZip';
import SafetyDataSheetsCatalogView from '@/components/safety-data-sheets/CatalogView';
import SafetyDataSheetsCatalogEdit from '@/components/safety-data-sheets/CatalogEdit';
import SafetyDataSheetsCatalogDelete from '@/components/safety-data-sheets/CatalogDelete';

//TRAINING COURSES
import TrainingCourseIndex from '@/components/training-courses/Index';
import TrainingCourseEdit from '@/components/training-courses/Edit';
import TrainingCourseView from '@/components/training-courses/View';
import TrainingCourseDelete from '@/components/training-courses/Delete';
import TrainingCourseImport from '@/components/training-courses/Import';
import TrainingCourseEmployee from '@/components/training-courses/EditEmployee';
import TrainingCourseEmployeeView from '@/components/training-courses/ViewEmployee';
import TrainingCourseEmployeeDelete from '@/components/training-courses/DeleteEmployee';
import AddCoursesToEmployee from '@/components/training-courses/AddCoursesToEmployee';
import AddEmployeesToCourse from '@/components/training-courses/AddEmployeesToCourse';
import TrainingCourseSetBulkExpiration from '@/components/training-courses/SetBulkExpiration';
import TrainingMatrix from '@/components/training-courses/Matrix';
import TrainingCompleted from '@/components/training-courses/Completed';
import TrainingPending from '@/components/training-courses/Pending';
import TrainingCourseAlertIndex from '@/components/training-courses/AlertIndex';
import TrainingCourseAlertEdit from '@/components/training-courses/AlertEdit';
import TrainingCourseAlertView from '@/components/training-courses/AlertView';
import TrainingCourseAlertDelete from '@/components/training-courses/AlertDelete';
import TrainingCatalogIndex from '@/components/training-courses/CatalogIndex';
import TrainingCatalogEdit from '@/components/training-courses/CatalogEdit';
import TrainingCatalogView from '@/components/training-courses/CatalogView';
import TrainingCatalogDelete from '@/components/training-courses/CatalogDelete';
import TrainingCourseDistribute from '@/components/training-courses/Distribute';

import HSEIndex from '@/components/HSEIndex';
import HSEView from '@/components/HSEView';
import HSEForm from '@/components/HSEForm';
import HSEAdvanceExport from '@/components/HSEAdvanceExport';
import HSEImport from '@/components/HSEImport';
import SearchResults from '@/components/SearchResults';
import SubcontractorIndex from '@/components/subcontractors/SubcontractorIndex';
import SubcontractorImport from '@/components/subcontractors/SubcontractorImport';
import SubcontractorView from '@/components/subcontractors/SubcontractorView';
import SubcontractorForm from '@/components/subcontractors/SubcontractorForm';
import SubcontractorDelete from '@/components/subcontractors/SubcontractorDelete';
import QualificationView from '@/components/subcontractors/QualificationView';
import QualificationForm from '@/components/subcontractors/QualificationForm';
import PublicAccessEdit from '@/components/subcontractors/PublicAccessEdit';
import SubQualificationReview from '@/components/subcontractors/QualificationReview';
import SubcontractorPrint from '@/components/subcontractors/PDF';
import SubUserIndex from '@/components/subcontractors/SubUserIndex';
import SubStatusHelp from '@/components/subcontractors/SubStatusHelp';
import OshaSubIndex from '@/components/subcontractors/OshaSubIndex';
import OshaSubView from '@/components/subcontractors/OshaSubView';

import OshaIndex from '@/components/OshaIndex';
import OshaForm from '@/components/OshaForm';

//ADMIN CONTROLLERS
import CorrectiveActionSettings from '@/components/admin/CorrectiveActionSettings';
import DisciplinaryViolations from '@/components/settings/DisciplinaryViolations';
import DisciplinaryViolationEdit from '@/components/settings/DisciplinaryViolationEdit';
import DisciplinaryViolationDelete from '@/components/settings/DisciplinaryViolationDelete';
import DivisionIndex from '@/components/settings/DivisionIndex';
import DivisionForm from '@/components/settings/DivisionForm';
import DivisionDelete from '@/components/settings/DivisionDelete';
import EquipmentTypeIndex from '@/components/settings/EquipmentTypeIndex';
import EquipmentTypeForm from '@/components/settings/EquipmentTypeForm';
import EquipmentTypeView from '@/components/settings/EquipmentTypeView';
import EquipmentAlertView from '@/components/settings/EquipmentAlertView';
import EquipmentAlertEdit from '@/components/settings/EquipmentAlertEdit';
import EquipmentAlertDelete from '@/components/settings/EquipmentAlertDelete';
import HseTypeIndex from '@/components/settings/HseTypeIndex';
import HseTypeForm from '@/components/settings/HseTypeForm';
import HseTypeDelete from '@/components/settings/HseTypeDelete';
import LicenseForm from '@/components/settings/LicenseForm';
import DesignationForm from '@/components/settings/DesignationForm';
import TradeForm from '@/components/settings/TradeForm';
import FieldTrainingForm from '@/components/settings/FieldTrainingForm';
import WorkAreaForm from '@/components/settings/WorkAreaForm';
import RegistrationForm from '@/components/settings/RegistrationForm';
import CompanySafetyProfile from '@/components/admin/CompanySafetyProfile';

import IncidentSettings from '@/components/settings/incidents/Settings';
import IncidentAlertView from '@/components/settings/incidents/IncidentAlertView';
import IncidentAlertEdit from '@/components/settings/incidents/IncidentAlertEdit';
import IncidentAlertDelete from '@/components/settings/incidents/IncidentAlertDelete';

import FacilityTypeEdit from '@/components/settings/FacilityTypeEdit';
import IncidentTypeForm from '@/components/settings/IncidentTypeForm';
import InjuryTypeForm from '@/components/settings/InjuryTypeForm';
import SafetySettingsIndex from '@/components/settings/SafetySettingsIndex';
import SafetySettingsForm from '@/components/settings/SafetySettingsForm';
import MajorBodyPartsForm from '@/components/settings/MajorBodyPartsForm';
import SpecificBodyPartsForm from '@/components/settings/SpecificBodyPartsForm';
import RecognitionForm from '@/components/settings/RecognitionForm';
import RoleIndex from '@/components/settings/RoleIndex';
import RolePermissions from '@/components/settings/RolePermissions';
import AccountSettings from '@/components/settings/AccountSettings';
import SubcontractorSettings from '@/components/settings/SubcontractorSettings';
import UserImport from '@/components/admin/UserImport';
import AdminRoleRequests from '@/components/admin/RoleRequests';
import SetupWizard from '@/components/admin/SetupWizard';

import AccountsIndex from '@/components/dev/AccountsIndex';
import AccountsView from '@/components/dev/AccountsView';
import AccountsEdit from '@/components/dev/AccountsEdit';
import AccountsBilling from '@/components/dev/AccountsBilling';
import DevUserView from '@/components/dev/UserView';
import DevUserEdit from '@/components/dev/UserEdit';

//RESELLER ACCOUNTS
import ResellerAccountsIndex from '@/components/resellers/AccountsIndex';
import ResellerAccountsView from '@/components/resellers/AccountsView';
import ResellerAccountsEdit from '@/components/resellers/AccountsEdit';
import ResellerUserView from '@/components/resellers/UserView';
import ResellerUserEdit from '@/components/resellers/UserEdit';
import ResellerUserLogin from '@/components/resellers/UserLogin';

//BILLING Controllers
import BillingIndex from '@/components/billing/Index';

import PasswordEmail from '@/components/PasswordEmail';
import PasswordReset from '@/components/PasswordReset';

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  base: '/',
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Layout,
      children: [
        { path: '', component: DashboardIndex },
        { path: 'bug', component: Bug },
        { path: '403', component: Page403 },
        { path: 'search/:term', component: SearchResults, props: true },
        { path: 'account-suspended', component: InActive },
        { path: '404', component: Page404 },
        { path: '409', component: Page409 },

        //ALERTS
        { path: 'alerts', component: AlertIndex },
        { path: 'alerts/view/:id', component: AlertView, props: true },

        //CHANGELOGS
        { path: 'changelogs', component: ChangelogIndex },
        { path: 'changelogs/view/:id', component: ChangelogView, props: true },
        { path: 'changelogs/create', component: ChangelogEdit },
        { path: 'changelogs/edit/:id', component: ChangelogEdit, props: true },
        { path: 'changelogs/delete/:id', component: ChangelogDelete, props: true },
        { path: 'changelogs/email/:id', component: ChangelogEmail, props: true },

        //CLIENTS
        { path: 'clients', component: ClientIndex },
        { path: 'clients/view/:id', component: ClientView, props: true },
        { path: 'clients/create', component: ClientForm },
        { path: 'clients/edit/:id', component: ClientForm, props: true },

        // SAFETY MEETINGS
        { path: 'custom-forms', component: CustomFormIndex },
        { path: 'custom-forms/entry/view/:id', component: CustomFormEntryView, props: true },
        { path: 'custom-forms/entry/create', component: CustomFormEntryEdit },
        { path: 'custom-forms/entry/edit/:id', component: CustomFormEntryEdit, props: true},
        { path: 'custom-forms/entry/status/:id', component: CustomFormEntryStatus, props: true},
        { path: 'custom-forms/entry/delete/:id', component: CustomFormEntryDelete, props: true},
        { path: 'custom-forms/forms/view/:id', component: CustomFormView, props: true },
        { path: 'custom-forms/forms/create', component: CustomFormEdit },
        { path: 'custom-forms/forms/edit/:id', component: CustomFormEdit, props: true},
        { path: 'custom-forms/forms/delete/:id', component: CustomFormDelete, props: true},
        { path: 'custom-forms/entry/pdf/:id/build', component: CustomFormBuildPDF, props: true},

        // DASHBOARD SETTINGS
        { path: 'dashboards/settings', component: DashboardSettings },
        { path: 'dashboards/settings/create', component: DashboardEdit },
        { path: 'dashboards/settings/edit/:id', component: DashboardEdit, props: true },
        { path: 'dashboards/settings/view/:id', component: DashboardView, props: true },
        { path: 'dashboards/settings/delete/:id', component: DashboardDelete, props: true },
        { path: 'dashboards/settings/subscribe/:id', component: DashboardSubscribe, props: true },

        // EMAIL Alerts
        { path: 'email-alerts/create', component: EmailAlertEdit, props: true},
        { path: 'email-alerts/edit/:id', component: EmailAlertEdit, props: true},
        { path: 'email-alerts/view/:id', component: EmailAlertView, props: true},
        { path: 'email-alerts/delete/:id', component: EmailAlertDelete, props: true},

        { path: 'equipment', component: EquipmentIndex },
        { path: 'equipment/view/:id', component: EquipmentView, props: true },
        { path: 'equipment/edit/:id', component: EquipmentEdit, props: true },
        { path: 'equipment/create', component: EquipmentEdit },
        { path: 'equipment/import', component: EquipmentImport },
        { path: 'equipment/usage/:equipment_id/edit/:id?', component: UsageForm, props: true },
        { path: 'equipment/tracking/:equipment_id/edit/:id?', component: TrackingForm, props: true },
        { path: 'equipment/types/view/:id', component: EquipmentTypeView, props: true},
        { path: 'equipment/types/edit', component: EquipmentTypeForm},
        { path: 'equipment/types/edit/:id', component: EquipmentTypeForm, props: true},

        //FILE & FOLDER Routes
        { path: 'files/edit/:id', component: FileEdit, props: true },
        { path: 'drive', component: DriveIndex },
        { path: 'drive/:id', component: DriveIndex, props: true },

        { path: 'incidents', component: IncidentIndex },
        { path: 'incidents/trend', component: IncidentTrend },
        { path: 'incidents/root-cause', component: IncidentRootCauseTrend },
        { path: 'incidents/osha', component: IncidentOsha },
        { path: 'incidents/view/:id', component: IncidentView, props: true },
        { path: 'incidents/create', component: IncidentCreate },
        { path: 'incidents/edit/:id', component: IncidentForm, props: true },
        { path: 'incidents/delete/:id', component: IncidentDelete, props: true },
        { path: 'incidents/change-type/:id', component: IncidentChangeType, props: true },
        { path: 'incidents/settings', component: IncidentSettings },
        { path: 'incidents/settings/incident-types/create', component: IncidentTypeForm},
        { path: 'incidents/settings/incident-types/edit/:id', component: IncidentTypeForm, props: true},
        { path: 'incidents/settings/incident-types/builder', component: IncidentBuilder },
        { path: 'incidents/settings/incident-types/builder/:id', component: IncidentBuilder, props: true },
        { path: 'incidents/settings/incident-types/publish/:id', component: IncidentTypePublish, props: true },
        { path: 'incidents/settings/injury-types/create', component: InjuryTypeForm},
        { path: 'incidents/settings/injury-types/edit/:id', component: InjuryTypeForm, props: true},
        { path: 'incidents/settings/major-body-parts/create', component: MajorBodyPartsForm},
        { path: 'incidents/settings/major-body-parts/edit/:id', component: MajorBodyPartsForm, props: true},
        { path: 'incidents/settings/specific-body-parts/create', component: SpecificBodyPartsForm},
        { path: 'incidents/settings/specific-body-parts/edit/:id', component: SpecificBodyPartsForm, props: true},
        { path: 'incidents/settings/facility-types/create', component: FacilityTypeEdit},
        { path: 'incidents/settings/facility-types/edit/:id', component: FacilityTypeEdit, props: true},
        { path: 'incidents/settings/alerts/view/:id', component: IncidentAlertView, props: true},
        { path: 'incidents/settings/alerts/edit/:id', component: IncidentAlertEdit, props: true},
        { path: 'incidents/settings/alerts/create', component: IncidentAlertEdit },
        { path: 'incidents/settings/alerts/delete/:id', component: IncidentAlertDelete, props: true},
        { path: 'incidents/import', component: IncidentImport },
        { path: 'incidents/edit/:id/override', component: IncidentOverride, props: true },

        { path: 'inspections', component: InspectionIndex },
        { path: 'inspections/view/:id', component: InspectionView, props: true },
        { path: 'inspections/create', component: InspectionEditAlt },
        { path: 'inspections/edit/:id', component: InspectionEditAlt, props: true },
        { path: 'inspections/result/:id', component: InspectionResultView, props: true },
        { path: 'inspections/delete/:id', component: InspectionDelete, props: true },
        { path: 'inspections/email-pdf/:id', component: InspectionEmailPDF, props: true },
        { path: 'inspections/build-pdf/:id', component: InspectionBuildPDF, props: true },
        { path: 'inspections/import', component: InspectionImport },
        { path: 'inspections/import/offline', component: InspectionImportOffline },

        { path: 'inspections/forms', component: FormIndex },
        { path: 'inspections/forms/create', component: FormEdit },
        { path: 'inspections/forms/edit/:id', component: FormEdit, props: true },
        { path: 'inspections/forms/view/:id', component: FormView, props: true },
        { path: 'inspections/forms/publish/:id', component: FormPublish, props: true },
        { path: 'inspections/forms/clone/:id', component: FormClone, props: true },
        { path: 'inspections/forms/delete/:id', component: FormDelete, props: true },
        { path: 'inspections/forms/import', component: FormImport, props: true },

        { path: 'jobsites', component: JobsiteIndex },
        { path: 'jobsites/view/:id', component: JobsiteView, props: true },
        { path: 'jobsites/create', component: JobsiteForm },
        { path: 'jobsites/edit/:id', component: JobsiteForm, props: true },
        { path: 'jobsites/merge/:id', component: JobsiteMerge, props: true },
        { path: 'jobsites/import', component: JobsiteImport },
        { path: 'jobsites/insurance/:jobsiteId/edit', component: JobsiteInsuranceEdit, props: true },
        { path: 'jobsites/insurance/:jobsiteId/edit/:insuranceId', component: JobsiteInsuranceEdit, props: true },

        // JSA
        { path: 'jsa', component: JsaIndex },
        { path: 'jsa/view/:id', component: JsaView, props: true },
        { path: 'jsa/create', component: JsaForm },
        { path: 'jsa/generate/:id', component: JsaForm, props: true },
        { path: 'jsa/edit/:id', component: JsaForm, props: true},
        { path: 'jsa/delete/:id', component: JsaDelete, props: true},
        { path: 'jsa/signature/:id', component: JsaEmployeeSignature, props: true},
        { path: 'jsa/settings/create', component: SafetySettingsForm},
        { path: 'jsa/settings/edit/:id', component: SafetySettingsForm, props: true},
        { path: 'jsa/templates', component: JsaTemplateIndex },
        { path: 'jsa/templates/create', component: JsaTemplateEdit },
        { path: 'jsa/templates/edit/:id', component: JsaTemplateEdit, props: true },
        { path: 'jsa/templates/view/:id', component: JsaTemplateView, props: true },
        { path: 'jsa/templates/delete/:id', component: JsaTemplateDelete, props: true },
        { path: 'jsa/reminders/create', component: JsaReminderEdit },
        { path: 'jsa/reminders/edit/:id', component: JsaReminderEdit, props: true },
        { path: 'jsa/reminders/delete/:id', component: JsaReminderDelete, props: true },

        { path: 'hse', component: HSEIndex },
        { path: 'hse/view/:id', component: HSEView, props: true },
        { path: 'hse/edit/:id', component: HSEForm, props: true },
        { path: 'hse/create', component: HSEForm },
        { path: 'hse/export', component: HSEAdvanceExport },
        { path: 'hse/import', component: HSEImport },

        // EMPLOYEES
        { path: 'employees', component: EmployeeIndex},
        { path: 'employees/view/:id', component: EmployeeView, props: true},
        { path: 'employees/create', component: EmployeeEdit },
        { path: 'employees/edit/:id', component: EmployeeEdit, props: true },
        { path: 'employees/equipment/:id', component: EmployeeAssignEquipment, props: true },
        { path: 'employees/recognition-list', component: EmployeeRecognitionIndex },
        { path: 'employees/recognition/edit/:id?', component: EmployeeRecognitionForm, props: true },
        { path: 'employees/recognition/view/:id', component: EmployeeRecognitionView, props: true },
        { path: 'employees/recognition/delete/:id', component: EmployeeRecognitionDelete, props: true },
        { path: 'employees/recognitions-types/edit', component: RecognitionForm},
        { path: 'employees/recognitions-types/edit/:id', component: RecognitionForm, props: true},
        { path: 'employees/merge/:id', component: EmployeeMerge, props: true},
        { path: 'employees/import', component: EmployeeImport },
        { path: 'employees/disciplinary-actions', component: DisciplinaryIndex },
        { path: 'employees/disciplinary-actions/view/:id', component: DisciplinaryView, props: true },
        { path: 'employees/disciplinary-actions/create', component: DisciplinaryEdit },
        { path: 'employees/disciplinary-actions/edit/:id', component: DisciplinaryEdit, props:true },
        { path: 'employees/disciplinary-actions/email/:id', component: DisciplinaryEmail, props:true },
        { path: 'employees/disciplinary-actions/delete/:id', component: DisciplinaryDelete, props:true },
        { path: 'employees/disciplinary-actions/alerts/create', component: DiscAlertEdit},
        { path: 'employees/disciplinary-actions/alerts/edit/:id', component: DiscAlertEdit, props: true},
        { path: 'employees/disciplinary-violations', component: DisciplinaryViolations},
        { path: 'employees/disciplinary-violations/create', component: DisciplinaryViolationEdit},
        { path: 'employees/disciplinary-violations/edit/:id', component: DisciplinaryViolationEdit, props: true},
        { path: 'employees/disciplinary-violations/delete/:id', component: DisciplinaryViolationDelete, props: true},
        { path: 'employees/recognitions/alerts/create', component: RecogAlertEdit},
        { path: 'employees/recognitions/alerts/edit/:id', component: RecogAlertEdit, props: true},
        { path: 'employees/settings', component: EmployeeSettings},

        // CORRECTIVE ACTIONS
        { path: 'corrective-actions', component: CorrectiveActionIndex},
        { path: 'corrective-actions/view/:id', component: CorrectiveActionView, props: true},
        { path: 'corrective-actions/edit/:id', component: CorrectiveActionEdit, props: true},
        { path: 'corrective-actions/delete/:id', component: CorrectiveActionDelete, props: true},
        { path: 'corrective-actions/complete/:id', component: CorrectiveActionComplete, props: true},

        // OBSERVATIONS
        { path: 'observations', component: ObservationIndex },
        { path: 'observations/view/:id', component: ObservationView, props: true },
        { path: 'observations/create', component: ObservationEdit },
        { path: 'observations/edit/:id', component: ObservationEdit, props: true},
        { path: 'observations/delete/:id', component: ObservationDelete, props: true},

        // SAFETY MEETINGS
        { path: 'safety-meetings', component: SafetyMeetingIndex },
        { path: 'safety-meetings/view/:id', component: SafetyMeetingView, props: true },
        { path: 'safety-meetings/create', component: SafetyMeetingEdit },
        { path: 'safety-meetings/edit/:id', component: SafetyMeetingEdit, props: true},
        { path: 'safety-meetings/delete/:id', component: SafetyMeetingDelete, props: true},
        { path: 'safety-meetings/email/:id', component: SafetyMeetingEmail, props: true },
        { path: 'safety-meetings/text/:id', component: SafetyMeetingText, props: true },

        // SAFETY DATA SHEETS
        { path: 'safety-data-sheets', component: SafetyDataSheetsIndex },
        { path: 'safety-data-sheets/view/:id', component: SafetyDataSheetsView, props: true },
        { path: 'safety-data-sheets/create', component: SafetyDataSheetsEdit },
        { path: 'safety-data-sheets/edit/:id', component: SafetyDataSheetsEdit, props: true},
        { path: 'safety-data-sheets/delete/:id', component: SafetyDataSheetsDelete, props: true},
        { path: 'safety-data-sheets/import-zip', component: SafetyDataSheetsImport},
        { path: 'safety-data-sheets/catalogs/create', component: SafetyDataSheetsCatalogEdit},
        { path: 'safety-data-sheets/catalogs/edit/:id', component: SafetyDataSheetsCatalogEdit, props: true},
        { path: 'safety-data-sheets/catalogs/view/:id', component: SafetyDataSheetsCatalogView, props: true},
        { path: 'safety-data-sheets/catalogs/delete/:id', component: SafetyDataSheetsCatalogDelete, props: true},

        //SUBCONTRACTORS
        { path: 'subcontractors', component: SubcontractorIndex},
        { path: 'subcontractors/import', component: SubcontractorImport},
        { path: 'subcontractors/view/:id?', component: SubcontractorView, props: true},
        { path: 'subcontractors/create', component: SubcontractorForm },
        { path: 'subcontractors/edit/:id', component: SubcontractorForm, props: true },
        { path: 'subcontractors/delete/:id', component: SubcontractorDelete, props: true },
        { path: 'subcontractors/users', component: SubUserIndex },
        { path: 'subcontractors/statuses', component: SubStatusHelp },
        { path: 'subcontractors/approvals', component: ClientApprovals },
        { path: 'subcontractors/approval-history/:id', component: SubApprovalView, props: true },

        //SUBCONTRACTOR PORTAL ROUTES
        { path: 'subcontractors/qualification/view/:id?', component: QualificationView, props: true },
        { path: 'subcontractors/qualification/edit/:id?', component: QualificationForm, props: true },
        { path: 'subcontractors/review/:id?', component: SubQualificationReview, props: true },
        { path: 'subcontractors/public-access/:id', component: PublicAccessEdit, props: true },

        // SUBCONTRACTOR OSHA ROUTES
        { path: 'subcontractors/osha-db', component: OshaSubIndex },
        { path: 'subcontractors/osha-db/view/:id', component: OshaSubView, props: true},

        // SUBCONTRACTOR SETTINGS
        { path: 'subcontractors/settings', component: SubcontractorSettings },
        { path: 'subcontractors/settings/areas-of-work/edit', component: WorkAreaForm},
        { path: 'subcontractors/settings/trades/create', component: TradeForm},
        { path: 'subcontractors/settings/trades/edit/:id', component: TradeForm, props: true},
        { path: 'subcontractors/settings/field-trainings/create', component: FieldTrainingForm},
        { path: 'subcontractors/settings/field-trainings/edit/:id', component: FieldTrainingForm, props: true},
        { path: 'subcontractors/settings/registrations/edit', component: RegistrationForm},
        { path: 'subcontractors/settings/licenses/create', component: LicenseForm},
        { path: 'subcontractors/settings/licenses/edit/:id', component: LicenseForm, props: true},
        { path: 'subcontractors/settings/designations/create', component: DesignationForm},
        { path: 'subcontractors/settings/designations/edit/:id', component: DesignationForm, props: true},

        // TRAINING COURSES
        { path: 'training-courses', component: TrainingCourseIndex },
        { path: 'training-courses/view/:id', component: TrainingCourseView, props: true },
        { path: 'training-courses/create', component: TrainingCourseEdit },
        { path: 'training-courses/edit/:id', component: TrainingCourseEdit, props: true },
        { path: 'training-courses/delete/:id', component: TrainingCourseDelete, props: true },
        { path: 'training-courses/set-bulk-expiration/:id', component: TrainingCourseSetBulkExpiration, props: true },
        { path: 'training-courses/import', component: TrainingCourseImport },
        { path: 'training-courses/employee/:id/view', component: TrainingCourseEmployeeView, props: true },
        { path: 'training-courses/employee/:id/delete', component: TrainingCourseEmployeeDelete, props: true },
        { path: 'training-courses/employee/:employeeId/add-courses', component: AddCoursesToEmployee, props: true },
        { path: 'training-courses/course/:id/add-employees', component: AddEmployeesToCourse, props: true },
        { path: 'training-courses/employee/:courseId/:empCourseId?', component: TrainingCourseEmployee, props: true },
        { path: 'training-courses/matrix', component: TrainingMatrix },
        { path: 'training-courses/completed', component: TrainingCompleted },
        { path: 'training-courses/pending', component: TrainingPending },
        { path: 'training-courses/alerts', component: TrainingCourseAlertIndex },
        { path: 'training-courses/alerts/create', component: TrainingCourseAlertEdit },
        { path: 'training-courses/alerts/edit/:id', component: TrainingCourseAlertEdit, props: true },
        { path: 'training-courses/alerts/view/:id', component: TrainingCourseAlertView, props: true },
        { path: 'training-courses/alerts/delete/:id', component: TrainingCourseAlertDelete, props: true },
        { path: 'training-courses/distribute/:method', component: TrainingCourseDistribute, props: true },

        { path: 'training-courses/catalogs', component: TrainingCatalogIndex },
        { path: 'training-courses/catalogs/create', component: TrainingCatalogEdit },
        { path: 'training-courses/catalogs/edit/:id', component: TrainingCatalogEdit, props: true },
        { path: 'training-courses/catalogs/view/:id', component: TrainingCatalogView, props: true },
        { path: 'training-courses/catalogs/delete/:id', component: TrainingCatalogDelete, props: true },

        //USERS
        { path: 'users', component: UserIndex},
        { path: 'users/view/:id', component: UserView, props: true },
        { path: 'users/create', component: UserForm, props: true },
        { path: 'users/edit/:id', component: UserForm, props: true },
        { path: 'users/impersonate/:id', component: UserImpersonate },
        { path: 'users/roles', component: RoleIndex },
        { path: 'users/roles/create', component: RolePermissions },
        { path: 'users/roles/edit/:id', component: RolePermissions, props: true },

        // REPORTS
        { path: 'reports/inspection-charts', component: ReportInspectionCharts },
        { path: 'reports/non-compliant-items', component: ReportInspectionResultsIndex },
        { path: 'reports/correlation-chart', component: ReportCorrelation },
        { path: 'reports/new-report', component: NewReport },
        { path: 'reports/avg-inspection-score-charts', component: ReportAvgInspectionScore },
        { path: 'reports/totals-charts', component: ReportAnalysis },
        { path: 'reports/inspection-results', component: InspectionResultsIndex },

        //REPORTS - INCIDENTS
        { path: 'reports/incidents/chart', component: ReportIncidentCharts },
        { path: 'reports/incidents/totals', component: ReportIncidentByTotals },
        { path: 'reports/incidents/root-cause', component: ReportRootCauseCharts },

        //AUTHENTICATED USER ONLY ROUTES
        { path: 'profile', component: Profile },
        { path: 'profile/request-roles', component: RoleRequest },
        { path: 'profile/jobsite', component: CurrentJobsite },
        { path: 'profile/reminders/edit/', component: InspectionReminderForm },
        { path: 'profile/reminders/edit/:id', component: InspectionReminderForm, props: true },

        { path: 'osha', component: OshaIndex },
        { path: 'osha/submit', component: OshaForm },

        //BILLING
        { path: 'billing', component: BillingIndex },

        //ADMIN
        { path: 'admin/corrective-actions', component: CorrectiveActionSettings },
        { path: 'admin/divisions', component: DivisionIndex },
        { path: 'admin/divisions-edit', component: DivisionForm},
        { path: 'admin/divisions-edit/:id', component: DivisionForm, props: true},
        { path: 'admin/divisions-delete/:id', component: DivisionDelete, props: true},
        { path: 'admin/equipment-types', component: EquipmentTypeIndex },
        // The type edits are an admin feature, but everyone needs to be able to view them, hence the weird route
        { path: 'admin/equipment-alerts/view/:id', component: EquipmentAlertView, props: true},
        { path: 'admin/equipment-alerts/edit/:id', component: EquipmentAlertEdit, props: true},
        { path: 'admin/equipment-alerts/create', component: EquipmentAlertEdit },
        { path: 'admin/equipment-alerts/delete/:id', component: EquipmentAlertDelete, props: true},
        { path: 'admin/hse-types', component: HseTypeIndex },
        { path: 'admin/hse-types-edit', component: HseTypeForm},
        { path: 'admin/hse-types-edit/:id', component: HseTypeForm, props: true},
        { path: 'admin/hse-types-delete/:id', component: HseTypeDelete, props: true},
        { path: 'admin/safety-settings', component: SafetySettingsIndex },
        { path: 'admin/settings', component: AccountSettings },
        { path: 'admin/import-users', component: UserImport },
        { path: 'admin/api-users', component: ApiUsersIndex },
        { path: 'admin/api-users/edit', component: ApiUsersEdit },
        { path: 'admin/api-users/edit/:id', component: ApiUsersEdit, props: true },
        { path: 'admin/api-users/view/:id', component: ApiUsersView, props: true },
        { path: 'admin/company-safety-profile', component: CompanySafetyProfile },
        { path: 'admin/setup-wizard', component: SetupWizard },

        //Developer Accounts
        { path: 'dev/accounts', component: AccountsIndex },
        { path: 'dev/accounts/view/:id', component: AccountsView, props: true },
        { path: 'dev/accounts/create', component: AccountsEdit},
        { path: 'dev/accounts/edit/:id', component: AccountsEdit, props: true},
        { path: 'dev/accounts/billing/:id', component: AccountsBilling, props: true},
        { path: 'dev/users/view/:id', component: DevUserView, props: true },
        { path: 'dev/users/create', component: DevUserEdit},
        { path: 'dev/users/edit/:id', component: DevUserEdit, props: true},

        //Reseller Accounts
        { path: 'resellers/accounts', component: ResellerAccountsIndex },
        { path: 'resellers/accounts/view/:id', component: ResellerAccountsView, props: true },
        { path: 'resellers/accounts/create', component: ResellerAccountsEdit},
        { path: 'resellers/accounts/edit/:id', component: ResellerAccountsEdit, props: true},
        { path: 'resellers/accounts/billing/:id', component: AccountsBilling, props: true},
        { path: 'resellers/users/view/:id', component: ResellerUserView, props: true },
        { path: 'resellers/accounts/users/:id/create', component: ResellerUserEdit},
        { path: 'resellers/accounts/users/:id/edit/:user_id', component: ResellerUserEdit, props: true},
        { path: 'resellers/accounts/login/:id', component: ResellerUserLogin, props: true},
      ]
    },
    {
      path: '/',
      component: LayoutBlank,
      children: [
        { path: 'sign-up', component: SignUp },
        { path: 'password/reset', component: PasswordEmail },
        { path: 'password/reset/:token', component: PasswordReset, props: true },
        { path: 'incidents/pdf/:id', component: IncidentPDF, props: true },
        { path: 'inspections/pdf/:id', component: InspectionPDF, props: true },
        { path: 'inspections/forms/pdf/:id', component: FormPDF, props: true },
        { path: 'subcontractors/print/:id?', component: SubcontractorPrint, props: true},
        { path: 'jsa/print/:id', component: JsaPDF, props: true},
        { path: 'jsa/templates/print/:id', component: JsaTemplatePDF, props: true},
        { path: 'employees/disciplinary-actions/pdf/:id', component: DisciplinaryPDF, props: true },
        { path: 'custom-forms/entry/pdf/:id', component: CustomFormPDF, props: true},
      ]
    }
  ]
})

router.afterEach((to, from) => {
  // On small screens collapse sidenav
  if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed())
  {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
  }

  if (store.state.toastObject)
  {
    let toastObject = store.state.toastObject;
    toastr.success(toastObject.msg, toastObject.title, toastObject);
    store.commit('toast', null);
  }

  // Scroll to top of the page
  globals().scrollTop(0, 0);

  //Check for a saved filter
  if(to.query.filter_id)
  {
    //Get the filter
    var filter = null;

    //Loop and locate
    for (var i = store.state.user.filters.length - 1; i >= 0; i--)
    {
        //Check the ID
        if(parseInt(store.state.user.filters[i].id) == parseInt(to.query.filter_id))
        {
            filter = store.state.user.filters[i];
        }
    }

    //Set all the value - this will also set it to NULL
    store.commit('setAppliedFilter', filter);
  }
  else if(store.state.appliedFilter) //If a filter exists in the store, but there is NO query param for a filter_id, NULL out the filter
  {
    //Set all the value - this will also set it to NULL
    store.commit('setAppliedFilter', null);
  }
})

router.beforeEach((to, from, next) => {
  // Set loading state
  document.body.classList.add('app-loading')

  // Add tiny timeout to finish page transition
  setTimeout(() => next(), 10);
})

export default router
